/*
 * Weekplan Messages
 *
 * This contains all the text for the Weekplan component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  showActionMenu: {
    id: 'app.containers.WeekActionsMenu.showActionMenu',
    defaultMessage: 'Show action menu',
  },
});
